
import React, { useState, useEffect } from 'react'
import axios from "axios";
import { APIURL } from "../../../Global";
import { NavDropdown } from "react-bootstrap";
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css'
import { ToggleButton, Badge,Button } from 'react-bootstrap';
import { ToggleButtonGroup } from 'react-bootstrap';
import DatePicker from "./Datepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import "../AdmissionReport/reports.css";
import isAfter from 'date-fns/isAfter';
import "rsuite/dist/rsuite.min.css";
import { DateRangePicker } from "rsuite";
import { Modal } from "react-bootstrap";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";
import { MdDownloadForOffline } from "react-icons/md";
import Nav from 'react-bootstrap/Nav';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import peaceImage from '../../../assets/images/icons/peacevillage.png'; 
function PaymentReports() {
  const [timePeriod, setTimePeriod] = useState("month")
  const [load, setLoad] = useState('')
  const [paymentData, setPaymentData] = useState([])
  const [refresh,setRefresh]=useState(false);
  const [totalAmount, setTotalAmount] = useState(" ")
  const [count, setCount] = useState(" ")
  const [serviceData, setServiceData] = useState([])
  const [rentalData, setRentalData] = useState([])
  const [category, setCategory] = useState('sr-order')
  const [fromDate, setFromDate] = useState(moment((new Date(new Date().getFullYear(), new Date().getMonth(), 1))).format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment((new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0))).format('YYYY-MM-DD'));
  const [tableCountDetails, setTableCountDetails] = useState([{ 'total_amount': '', 'count': '' }])
  const [checked, setChecked] = useState(true);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1)
  const [hasNext, setHasNext] = useState(false)
  const [selectedValue, setSelectedValue] = useState(''); // You can set the initial selected value here
  const [currentDay, setCurrentDay] = useState(moment().format('YYYY-MM-DD'));
  const [currentMonth, setCurrentMonth] = useState(moment().format('MMMM'));
  const [monthsYear, setMonthsYear] = useState(moment().format('YYYY'));
  const [confirmed, setConfirmed] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedYears, setSelectedYears] = useState([]);
  const currentYear = new Date().getFullYear();
  const [selectedDownload, setSelectedDownload] = useState([]);

  useEffect(() => {    
   
    setPaymentData([])
    apiCallFilter(1,10);
   setFromDate("")
   setToDate("")
   setSelectedValue("")
      
  }, [refresh]);
  
  const handleDownload = (option) => {
    setSelectedDownload((prevSelection) => {
      if (prevSelection.includes(option)) {
        return prevSelection.filter((selectedOption) => selectedOption !== option);
      } else {
        return [...prevSelection, option];
      }
    });
  };
  const handleDownloads = () => {
    console.log('Selected Downloads:', selectedDownload);

    // Perform actions based on selected download options
    selectedDownload.forEach((selectedOption) => {
      if (selectedOption === 'PDF') {

        const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Patient Payment Details";
    const headers = [["Patient Name", "Paid For", "Date", "PAyment Mode", "Paid Amount", "Total Amount"]];

    const data = paymentData.map(elt => [elt.patient, elt.paid_for, moment(new Date(elt.payment_date)).format('YYYY-MM-DD'), elt.is_counter_paid ? "Counter" : "Online", elt.amount_paid, elt.total_amount]);

    let content = {
      startY: 50,
      head: headers,
      body: data
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("payment_report.pdf")
    } else if (selectedOption === 'CSV') {

      // const filteredData = paymentData.map(elt => ({
      //   patine_name: elt.patient, 
      //   paid_for: elt.paid_for, 
      //   payment_date: moment(new Date(elt.payment_date)).format('YYYY-MM-DD'), 
      //   payment_mode: elt.is_counter_paid ? "Counter" : "Online", 
      //   amount_paid: elt.amount_paid, 
      //   total_amount: elt.total_amount
      // }));

        // Generate CSV content
        const csvContent =
          CsvRegisterheaders.map((h) => h.label).join(',') +
          '\n' +
          paymentData.map((row) => Object.values(row).join(',')).join('\n');
        
        // Create a Blob and download the CSV file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'payment_report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);      
    }
  });

    // Reset selected downloads
    setSelectedDownload([]);

    setConfirmed(false)
  };

  

   const exportRegisterReport = () =>{
    setConfirmed(true)
 }


  const ApprovePopUp = (props) => {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        
      >
        <Modal.Header style={{height:'50px'}} closeButton>
          <Modal.Title  id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body style={{height:'200px',display: 'flex', flexDirection: 'column', justifyContent: 'center',alignItems:'center'}}>
          <h4>Select the format you want to download</h4>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ marginBottom: '5px' }}>
              <input
                type="checkbox"
                checked={selectedDownload.includes('PDF')}
                onChange={() => handleDownload('PDF')}
              />
              PDF
            </label>
            
              <label  style={{ marginBottom: '5px' }}>
                <input
                  type="checkbox"
                  checked={selectedDownload.includes('CSV')}
                  onChange={() => handleDownload('CSV')}
                />
                CSV
              </label>
          
           </div>
           <button variant="primary" className='buttonfilter' style={{width: '100px',height: '32px', fontSize: '11px' }} onClick={handleDownloads}>
            <span>Download</span>
          </button>
        </Modal.Body>
        
      </Modal>
    );
    }
   
  useEffect(() => {
    if (category) {
      apiCallFilter(1, perPage)
    }

  }, [category]);

  useEffect(() => {
    if (fromDate) {
      apiCallFilter(1, perPage)
    }

  }, [fromDate,toDate]);


  const handleChangeRadio = (val) => {
    paymentData.splice(0, paymentData.length + 1)
    setCategory(val);

    
  }

  const handleChangeValue = (val) => {
    paymentData.splice(0, paymentData.length + 1)
    
      console.log('week');
      var startOfWeek = moment().startOf('week').toDate();
      var endOfWeek = moment().endOf('week').toDate();

      var FormatedFirstday = moment((startOfWeek)).format('YYYY-MM-DD');
      var Formatedlastday = moment((endOfWeek)).format('YYYY-MM-DD');
      setFromDate(FormatedFirstday)
      setToDate(Formatedlastday)
      setSelectedValue('week');

    
  }

  const handleDayChange = (increment) => {
    paymentData.splice(0, paymentData.length + 1)

    const newDate = moment(currentDay).add(increment, 'days');
  
    // Set maximum date to the current date
    if (newDate.isAfter(moment(), 'day')) {
      setCurrentDay(moment().format('YYYY-MM-DD'));
      return;
    }
  
    setFromDate(newDate.format('YYYY-MM-DD'));
    setToDate(newDate.format('YYYY-MM-DD'));
    setCurrentDay(newDate.toDate());

    setSelectedValue('day');
  };


  const handleMonthChange = (increment) => {
    paymentData.splice(0, paymentData.length + 1)
    const currentMoment = moment(`${monthsYear}-${currentMonth}`, 'YYYY-MMMM');
    const newMoment = currentMoment.add(increment, 'months');

    // Set minimum month to one year back
    const minMonth = moment().subtract(1, 'year').endOf('month')-1;
    if (newMoment.isSameOrBefore(minMonth, 'month')) {
      setCurrentMonth(minMonth.format('MMMM'));
      setMonthsYear(minMonth.format('YYYY'));
      return;
    }

    // Set maximum month to the current month
    if (newMoment.isAfter(moment(), 'month')) {
      setCurrentMonth(moment().format('MMMM'));
      setMonthsYear(moment().format('YYYY'));
      return;
    }

   
      const startOfMonth = newMoment.startOf('month').format('YYYY-MM-DD');
      const endOfMonth = newMoment.endOf('month').format('YYYY-MM-DD');
  
      setFromDate(startOfMonth);
      setToDate(endOfMonth);
   
    setCurrentMonth(newMoment.format('MMMM'));
    setMonthsYear(newMoment.format('YYYY'));

    setSelectedValue('month');

  };

  const generateYearOptions = () => {
    const years = [];
    for (let year = 2022; year <= currentYear; year++) {
      years.push(String(year));
    }
    return years;
  };

  const filterOptions = [ ...generateYearOptions()];

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };


  const handleFilterChange = (filter) => {
    setSelectedYears((prevYears) => {
      if (prevYears.includes(filter)) {
        // Deselect the checkbox
        return [];
      } else {
        // Select the checkbox and disable others
        return [filter];
      }
    });
  };
  

  const handleApplyFilters = () => {
    paymentData.splice(0, paymentData.length + 1)

    if (selectedYears.length > 0) {
      const sortedYears = selectedYears.sort((a, b) => Number(a) - Number(b));
  
      const startDate = sortedYears[0] + '-01-01';
      const endDate = sortedYears[selectedYears.length - 1] + '-12-31';
  
      setFromDate(startDate);
      setToDate(endDate);
  
      console.log(`Start Date:`, startDate);
      console.log(`End Date:`, endDate);
  
    }
  
    setSelectedYears([]);
    setIsDropdownOpen(false);
    setSelectedValue('');

  };

  const apiCallFilter = (page, per_page) => {

    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '')
    const a = fromDate;
    const b = toDate;

    axios.get(`${APIURL}/api/v1/service-provider/hospital-payment-reports/?start_date=${a}&end_date=${b}&type=${category}&page=${page}&per_page=${per_page}`, {
      headers: {

        "Authorization": 'Token ' + str
      }
    })
      .then(res2 => {

        if (res2.data.status === "success") {

          setLoad('')
          setHasNext(res2.data.has_next)
          let datalist4 = res2.data.payments
          setTotalRows(res2.data.total_records)
          setPaymentData([...paymentData,...datalist4])
        
        }
        else {
          setLoad('Error in Fetching Data')
        }

      })



  }

  const handleEvent = (event, picker) => {
    paymentData.splice(0, paymentData.length + 1)
    const a = moment(event[0]).format('YYYY-MM-DD');
    let b = moment(event[1]).format('YYYY-MM-DD');

    // apiCallFilter(1, 10);
    setFromDate(a);
    setToDate(b);
    setSelectedValue('daterangepicker');
    
  }




  const renderTable = (cellInfo) => {

    return (
      <div style={{ color: "black",textTransform: "capitalize" }}>{paymentData[cellInfo.index][cellInfo.column.id]}</div>
    )
  }
  const renderPaidfor = (cellInfo) => {

    return (
      <div style={{ color: "black",textTransform: "capitalize" }}>{paymentData[cellInfo.index][cellInfo.column.id]==="sr-order"?"Service Order"
      :paymentData[cellInfo.index][cellInfo.column.id]==="test"?"Lab Test"
      :paymentData[cellInfo.index][cellInfo.column.id]==="misc"?"Miscellaneous"
        :paymentData[cellInfo.index][cellInfo.column.id]}</div>
    )
  }

  const renderStatus = (cellInfo) => {
    if (paymentData[cellInfo.index][cellInfo.column.id] === true) {
      return (

        <div style={{ color: "black" }}>Counter</div>
      )
    }
    else {
      return (

        <div style={{ color: "black" }}>Online</div>
      )
    }
  }
  const renderDate = (cellInfo) => {
    let dateString = paymentData[cellInfo.index][cellInfo.column.id]
    let dateObject = new Date(dateString);

    const updatedDate = dateObject.toString();
    return (
      <div style={{ color: "black" }}>
        {updatedDate.slice(4, 16)}

      </div>
    )
  }



  const columns = [
    {
      Header: "Name",
      accessor: "patient",
      Cell: renderTable,
      style: {
        backgroundColor: "rgba(0,0,0,0.1)"
      },
      sortable: true,
      filterable: true,

      // width: 210

    },
    {
      Header: "Paid for",
      accessor: "paid_for",
      Cell: renderPaidfor,
      style: {
        backgroundColor: "rgba(0,0,0,0.1)"
      },
      sortable: true,
      filterable: true,

      // width: 210

    },
    {
      Header: "Date",
      accessor: "payment_date",
      Cell: renderDate,
      style: {
        backgroundColor: "rgba(0,0,0,0.1)"
      },
      sortable: true,
      filterable: true,

      // width: 210

    },

    {
      Header: "Payment Mode",
      accessor: "is_counter_paid",
      Cell: renderStatus,

      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
      },
      // width: 210

    },

    {
      Header: "Paid Amount",
      accessor: "amount_paid",
      Cell: renderTable,
      sortable: true,
      filterable: true,
      // width: 210

    },
    {
      Header: "Total Amount",
      accessor: "total_amount",
      Cell: renderTable,
      sortable: true,
      filterable: true,
      // width: 210

    }
  ]
  const handlePageChange = page => {
    if (hasNext) {
      apiCallFilter(page + 1, perPage);
    }
  }

  const handlePerRowsChange = async (newPerPage, pageindex) => {
    setPerPage(newPerPage)
    paymentData.splice(0, paymentData.length + 1)
    apiCallFilter(1, newPerPage);

  }
  useEffect(() => {
    apiCallFilter(page, perPage);
  }, [perPage]);

  const handleRefresh =(e)=>{
    
    e.preventDefault();
   
    setPaymentData([]);
    
    setPage(1);
    setFromDate("")
    setToDate("")
    setRefresh(!refresh)
  }
  const display = <ReactTable
    columns={columns}
    data={paymentData}
    defaultPageSize={perPage - 1}
    pageSizeOptions={[perPage - 1,10, 20, 25, 50,100]}
    className='calllog-table'
    resizable
    pagination
    paginationServer
    onPageChange={(pageIndex) => { handlePageChange(pageIndex); setPage(pageIndex + 1) }}
    paginationTotalRows={totalRows}
    onPageSizeChange={handlePerRowsChange}
  ></ReactTable>


  const CsvRegisterheaders = [
    { label: "Patient Name", key: "patient" },
    { label: "Paid For", key: "paid_for" },
    { label: "Date", key: "payment_date" },
    { label: "Paid Amount", key: "amount_paid" },
    { label: "Total Amount", key: "total_amount" },

  ];
 

  return (
    <>
    <div className="patient-report"> 
      <Nav className="row" style={{ marginTop: "1%",alignContent:'center',boxSizing: 'border-box' }}>
        <span className="col-6" style={{ width: '35.7%' }}>  
          <button className="buttonfilter" style={{ marginTop: "1%", borderRadius: "25px", width: "90px", background: "#1269B9",fontSize:"11px" }} onClick={(e) => handleRefresh(e)}>
            <span>Refresh &nbsp;<i className="fa fa-refresh" aria-hidden="true" style={{ color: "white" }}></i> </span>
          </button> 
        </span>
        <span className="col-6 togglegroup" style={{display:'flex', marginBottom: "1%", textAlign: "right", float: 'right' }}>
          <ToggleButtonGroup style={{ marginTop: "1%", fontSize: "small"}} type="radio" name="options" >
            <DateRangePicker
              appearance="default"              
              placeholder={"Select Date Range"}  
              onChange={handleEvent}
              disabledDate={(date) => isAfter(date, new Date())}
             >
              <ToggleButton id="tbg-radio-4" value={'custom'} className="btn btn-light toggle-btns custombtn1" style={{ border: 'none',fontSize:'11px'}}></ToggleButton>
            </DateRangePicker>&nbsp;&nbsp;&nbsp;
        
            <div style={{ display: 'flex', alignItems: 'center', height: '30px', fontSize: '11px', paddingTop: '0px', paddingBottom: '0px', border: `1px solid ${selectedValue === 'day' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}>
              <button className='arrowButton'  onClick={() => handleDayChange(-1)}>
                {<AiFillCaretLeft />}
              </button>
              <span style={{ margin: '0 8px', width: '50px', textAlign: 'center', fontSize:'11px' }}>
                {moment(currentDay).isSame(moment(), 'day') ? 'Today' : moment(currentDay).format('YYYY/MM/DD')}
              </span>
              <button className='arrowButton' onClick={() => handleDayChange(1)}>
                {<AiFillCaretRight />}
              </button>
            </div>&nbsp;&nbsp;&nbsp;
        
            <div style={{ display: 'flex', alignItems: 'center',height: '30px', fontSize: '11px', fontWeight: '400px', border: `1px solid ${selectedValue === 'month' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}>
              <button className='arrowButton' onClick={() => handleMonthChange(-1)}>
                {<AiFillCaretLeft />}
              </button>
              <span style={{ margin: '0 4px', width: '50px', textAlign: 'center' }}>{currentMonth}</span>
              <button className='arrowButton' onClick={() => handleMonthChange(1)}>
                {<AiFillCaretRight />}
              </button>
            </div>&nbsp;&nbsp;&nbsp;
            <button   
              style={{ display: 'flex',justifyContent:'center',alignItems:'center', height: '30px',width:'50px', fontSize: '11px',backgroundColor:'white', fontWeight: '400px', border: `1px solid ${selectedValue === 'week' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }} 
              onClick={() => handleChangeValue('week')}
            > 
              <span>Week</span>
            </button>&nbsp;&nbsp;&nbsp;
            <div style={{ position: 'relative' }}>
              <button
                className="buttonfilter" 
                style={{ borderRadius: "20px",height: '32px', width: '60px', fontSize: '11px', background: isDropdownOpen ? "rgb(13, 197, 197)" : " #1269B9" }}
                onClick={toggleDropdown}
              >
                <span>Filters</span>
              </button>
              {isDropdownOpen && (
              <div
              style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                padding: '10px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
                width:'100px',
                alignItems:'center',
              }}>
                {filterOptions.map((filter) => (
              <label key={filter} style={{ marginBottom: '5px' }}>
              <input
                type="checkbox"
                checked={selectedYears.includes(filter)}
                onChange={() => handleFilterChange(filter)}
                //disable others if one is selected
                disabled={selectedYears.length > 0 && !selectedYears.includes(filter)}
              />&nbsp;
               {filter}
              </label>
                ))} 
                <button disabled={selectedYears.length===0} style={{ marginTop: '10px' }} onClick={handleApplyFilters}>
                  Apply
                </button>
              </div>
              )}
            </div>&nbsp;     
            <button className='buttonfilter' style={{ width: '100px',height: '32px', fontSize: '11px' }} onClick={exportRegisterReport}>
              <span>Download  <MdDownloadForOffline /></span>
            </button>
          </ToggleButtonGroup> 
      </span>    
    </Nav>


        <div className="service-table-holder" style={{  }}> {load === '' ? display
          : load === 'Error in Fetching Data' ? <h6 style={{ color: "red" }}>{load}</h6> : <h6 style={{ color: "grey" }}>{load}</h6>}
        </div>
      </div>
      <br />
      {confirmed ? (
      <ApprovePopUp
        show={confirmed}
        onHide={() => {
          setConfirmed(false);
        }}
      />
    ) : null}
    </>

  )
}

export default PaymentReports
